/* eslint-disable no-debugger */
import { Checkbox } from "@mui/material";
import React from "react";
import { CustomTable, CustomTableHead, CustomTableRow, CustomTableCell, CustomTableBody } from "..";
import Loader from "../../../../navigation/routes/components/Loader";
import { translate } from "../../../providers";
import { CustomButton } from "../../buttons";
import { I18nTranslate } from "../../i18n";
import { icon } from "../../icon-component";
import { UserAvatar } from "../../user-avatar";
import styles from "./UsersTable.module.css";
import { EmptyState } from "../../empties";
import { CustomTooltip } from "../../tooltip";

export default function UsersTable({
	checkedUsers,
	className = "",
	companyId,
	emptyStateButton,
	emptyStateText,
	isLoading,
	onCheckAll,
	onCheckUser,
	onOpenDialog,
	searchText = "",
	users,
}) {
	return (
		<div className={className}>
			<CustomTable className={styles.table}>
				<CustomTableHead>
					<CustomTableRow className={styles.row}>
						<CustomTableCell className={styles["check-cell"]}>
							<Checkbox
								checked={checkedUsers.length === users.length && users.length !== 0}
								color="primary"
								onChange={onCheckAll}
							/>
						</CustomTableCell>
						<CustomTableCell className={styles["avatar-cell"]} />
						<CustomTableCell className={styles["name-cell"]}>
							{translate("common:components.users-table.header.first-name")}
						</CustomTableCell>
						<CustomTableCell className={styles["name-cell"]}>
							{translate("common:components.users-table.header.last-name")}
						</CustomTableCell>
						<CustomTableCell className={styles["email-cell"]}>
							{translate("common:components.users-table.header.email")}
						</CustomTableCell>
					</CustomTableRow>
				</CustomTableHead>
				<CustomTableBody>
					{(Array.isArray(users) &&
						!isLoading &&
						users.length > 0 &&
						users.map((user) => (
							<CustomTableRow key={user.email} className={styles.row}>
								<CustomTableCell className={styles["check-cell"]}>
									<Checkbox
										checked={checkedUsers.some((u) => u.email === user.email)}
										color="primary"
										onChange={() => onCheckUser(user)}
									/>
								</CustomTableCell>
								<CustomTableCell className={styles["avatar-cell"]}>
									<UserAvatar
										companyId={companyId}
										displayName={user.displayName}
										email={user.email}
										firstName={user.firstname || user.firstName}
										lastName={user.lastname || user.lastName}
										size="sm"
										userId={user.id}
									/>
								</CustomTableCell>
								<CustomTableCell autoTranslate="no" className={styles["name-cell"]}>
									<CustomTooltip placement="top-start" title={user.firstname || user.firstName}>
										{user.firstname || user.firstName}
									</CustomTooltip>
								</CustomTableCell>
								<CustomTableCell autoTranslate="no" className={styles["name-cell"]}>
									<CustomTooltip placement="top-start" title={user.lastname || user.lastName}>
										{user.lastname || user.lastName}
									</CustomTooltip>
								</CustomTableCell>
								<CustomTableCell autoTranslate="no" className={styles["email-cell"]}>
									<CustomTooltip placement="top-start" title={user.email}>
										{user.email}
									</CustomTooltip>
								</CustomTableCell>
							</CustomTableRow>
						))) ||
						(searchText && !isLoading && (
							<CustomTableRow>
								<CustomTableCell align="center" className={styles["empty-row"]} colSpan={5}>
									<I18nTranslate
										className={styles["empty-row__text"]}
										param={{ searchText }}
										translationKey="common:components.users-table.empty"
									/>
									<CustomButton startIcon={icon.faPlus} variant="outlined" onClick={onOpenDialog}>
										{translate("common:components.users-table.empty.add-button")}
									</CustomButton>
								</CustomTableCell>
							</CustomTableRow>
						))}
				</CustomTableBody>
			</CustomTable>
			{!isLoading && Array.isArray(users) && users.length === 0 && !searchText && (
				<EmptyState btn1={emptyStateButton()} className={styles["empty-state"]} title={emptyStateText} />
			)}
			{isLoading && (
				<div className={styles["loader-container"]}>
					<Loader />
				</div>
			)}
		</div>
	);
}
